"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputAdornment = function InputAdornment(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.component,
      disabled = _ref.disabled,
      disablePointerEvents = _ref.disablePointerEvents,
      position = _ref.position;
  var adornmentClasses = (0, _classnames.default)(className, {
    'pds-input-adornment': true,
    'pds-input-adornment--start': position === 'start',
    'pds-input-adornment--end': position === 'end',
    'pds-input-adornment--disabled': disabled,
    'pds-input-adornment--disablePointerEvents': disablePointerEvents
  });
  return _react.default.createElement(Component, {
    className: adornmentClasses
  }, children);
};

InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.node.isRequired,
  className: _propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  disabled: _propTypes.bool,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: _propTypes.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: (0, _propTypes.oneOf)(['start', 'end']).isRequired
};
InputAdornment.defaultProps = {
  className: null,
  component: 'div',
  disabled: false,
  disablePointerEvents: false
};
var _default = InputAdornment;
exports.default = _default;
